import { createContext, ReactElement, useLayoutEffect, useMemo } from "react";
import type { CustomButtonProps } from "../CustomButton";

interface ActionMenuTriggerBridge {
  register: (props: CustomButtonProps) => void;
  unregister: () => void;
}

export const ActionMenuTriggerContext =
  createContext<ActionMenuTriggerBridge | null>(null);

export function ActionMenuTriggerRegistration({
  bridge,
  buttonProps,
}: {
  bridge: ActionMenuTriggerBridge;
  buttonProps: CustomButtonProps;
}) {
  useLayoutEffect(() => {
    bridge.register(buttonProps);
  });

  useLayoutEffect(() => () => bridge.unregister(), [bridge]);

  return null;
}

export function ActionMenuComponent({
  id,
  component,
  onRegister,
  onUnregister,
}: {
  id: string;
  component: ReactElement;
  onRegister: (id: string, props: CustomButtonProps) => void;
  onUnregister: (id: string) => void;
}) {
  const bridge = useMemo(
    () => ({
      register: (props: CustomButtonProps) => onRegister(id, props),
      unregister: () => onUnregister(id),
    }),
    [id, onRegister, onUnregister],
  );

  return (
    <ActionMenuTriggerContext.Provider value={bridge}>
      {component}
    </ActionMenuTriggerContext.Provider>
  );
}
